import { ArrowLeft, ChevronLeft, ChevronRight, Pause, Volume2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { Progress } from '@/components/ui/progress'

interface RecipeCookingModeProps {
  currentStep: number
  instructions: string[]
  isSpeaking: boolean
  onBack: () => void
  onPrevious: () => void
  onNext: () => void
  onToggleSpeaking: () => void
}

export function RecipeCookingMode({
  currentStep,
  instructions,
  isSpeaking,
  onBack,
  onPrevious,
  onNext,
  onToggleSpeaking,
}: RecipeCookingModeProps) {
  const progress = ((currentStep + 1) / instructions.length) * 100

  return (
    <div className="min-h-screen bg-gray-50 p-4">
      <div className="mx-auto max-w-4xl">
        <div className="mb-6 flex items-center justify-between">
          <Button variant="outline" onClick={onBack}>
            <ArrowLeft className="mr-2 h-4 w-4" />
            Terug naar recept
          </Button>

          <Button variant="outline" size="sm" onClick={onToggleSpeaking}>
            {isSpeaking ? <Pause className="h-4 w-4" /> : <Volume2 className="h-4 w-4" />}
          </Button>
        </div>

        <div className="mb-8">
          <div className="mb-2 flex items-center justify-between">
            <span className="text-sm font-medium">
              Stap {currentStep + 1} van {instructions.length}
            </span>
            <span className="text-sm text-gray-500">{Math.round(progress)}%</span>
          </div>
          <Progress value={progress} />
        </div>

        <Card className="mb-8">
          <CardContent className="p-8">
            <div className="text-center">
              <div className="mb-6 inline-flex h-16 w-16 items-center justify-center rounded-full bg-orange-500 text-2xl font-bold text-white">
                {currentStep + 1}
              </div>
              <p className="text-2xl leading-relaxed text-gray-800 md:text-3xl">{instructions[currentStep]}</p>
            </div>
          </CardContent>
        </Card>

        <div className="flex items-center justify-between">
          <Button variant="outline" size="lg" onClick={onPrevious} disabled={currentStep === 0}>
            <ChevronLeft className="mr-2 h-5 w-5" />
            Vorige
          </Button>

          <Button size="lg" onClick={onNext} disabled={currentStep === instructions.length - 1}>
            Volgende
            <ChevronRight className="ml-2 h-5 w-5" />
          </Button>
        </div>
      </div>
    </div>
  )
}
